var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification",attrs:{"id":"verification"}},[_c('h3',[_vm._v("Verification")]),_vm._v(" "),_c('uploaded-files'),_vm._v(" "),(!_vm.checkUserData)?_c('edit-data'):_vm._e(),_vm._v(" "),(_vm.checkUserData && !_vm.isVerified)?_c('upload-files'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7419f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/content/profile/Verification.vue
// module id = zdo5
// module chunks = 0